// @ts-nocheck
import { put, takeLatest } from 'redux-saga/effects';
import { toggleLoaderState, updateComponentRequestStatus} from './reducer';
import { handleComponentStatus, toggleLoader } from './sagaActions';

export function* handleToggleLoader({ payload: { isLoading, component } }) {
	yield put(toggleLoaderState({ isLoading, component }));
}

export function* handleComponentRequestStatus({ payload: { isLoading, component, status, message} }) {
	yield put(updateComponentRequestStatus({ isLoading, component,status, message }));
}

export default function* rootSaga() {
	return [
		yield takeLatest(toggleLoader, handleToggleLoader),
		yield takeLatest(handleComponentStatus, handleComponentRequestStatus),
	];
}
